import $ from "jquery";

$(function () {
    //console.log("[ARCHITECT] JS działa w partialu");

    const cookieName = "architect_allowed_download";
    const buttonClass = ".architect-download-btn a";
    const popupId = '18769';

    function hasCookie(name) {
        return document.cookie
            .split(";")
            .some((c) => c.trim().startsWith(name + "="));
    }

    // Obsługa kliknięcia przycisku
    $(document).on("click", buttonClass, function (e) {
        if (!hasCookie(cookieName)) {
            e.preventDefault();
            //console.log("[ARCHITECT] Brak cookie – otwieram popup");

            if (typeof elementorProFrontend !== "undefined") {
                elementorProFrontend.modules.popup.showPopup({ id: popupId });
            } else {
                //console.warn("[ARCHITECT] Brak elementorProFrontend");
            }
        } else {
            //console.log("[ARCHITECT] Cookie istnieje – pozwalam pobrać plik");
        }
    });

    // Obsługa ustawiania cookie po wysłaniu formularza
    if (typeof elementorFrontend === "undefined") {
        //console.warn("[ARCHITECT] elementorFrontend undefined");
        return;
    }

    elementorFrontend.hooks.addAction(
        "frontend/element_ready/form.default",
        function ($scope, $) {
            //console.log("[ARCHITECT] Formularz gotowy");

            if (
                typeof elementorProFrontend !== "undefined" &&
                typeof elementorProFrontend.modules !== "undefined" &&
                typeof elementorProFrontend.modules.forms !== "undefined"
            ) {
                elementorProFrontend.modules.forms.ajaxResponseCallbacks.allow_architect_download =
                    function (response, $form) {
                        //console.log("[ARCHITECT] Callback odpalony");

                        if (response.data.download_allowed) {
                            const d = new Date();
                            d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 dni
                            const expires = "expires=" + d.toUTCString();
                            document.cookie =
                                "architect_allowed_download=true; " +
                                expires +
                                "; path=/";

                            // console.log(
                            //     "[ARCHITECT] Cookie ustawione na true (30 dni)"
                            // );
                        }
                    };
            }
        }
    );
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/elementor-download-cookie.js